import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export const useAuthValidation = (maxRetries = 3, retryDelay = 1000) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    let retryCount = 0;
    let timeoutId;

    const validateToken = async () => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const response = await api.get(`${process.env.REACT_APP_API}/admin/validate-token`);
        
        if (!response.valid) {
          if (retryCount < maxRetries) {
            retryCount++;
            //console.log(`Token validation attempt ${retryCount} of ${maxRetries}`);
            timeoutId = setTimeout(validateToken, retryDelay);
            return;
          }
          
          localStorage.removeItem('token');
          navigate('/login');
        }
      } catch (error) {
        if (retryCount < maxRetries) {
          retryCount++;
          console.log(`Token validation attempt ${retryCount} of ${maxRetries}`);
          timeoutId = setTimeout(validateToken, retryDelay);
          return;
        }

        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      }
    };

    validateToken();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [navigate, maxRetries, retryDelay]);
};